"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _lodash = require("lodash");

var _bezierEasing = _interopRequireDefault(require("bezier-easing"));

var _AnimatorView = _interopRequireDefault(require("./AnimatorView"));

var _Range = _interopRequireDefault(require("../../../../utilities/transcriptLib/Range"));

var _compareRangeLists = _interopRequireDefault(require("../../../../utilities/transcriptLib/compareRangeLists"));

var _connectToScroller = _interopRequireDefault(require("../connectToScroller"));

var _connectToTranscript = _interopRequireDefault(require("../connectToTranscript"));

var _PropsToStateComponent = _interopRequireDefault(require("../../../../utilities/transcriptLib/PropsToStateComponent"));

var _constants = require("../../../../utilities/transcriptLib/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SCROLL_INTERVAL = 1200;
var easing = (0, _bezierEasing["default"])(0, 0.5, 0.5, 1);
/**
 * returns true if the difference between the numbers are greater than the delta
 * @param time {Number?}
 * @param base {Number?}
 * @param delta {float} HOW different two numbers have to be.
 * @returns {boolean}
 */

var timeIsSignificantlyDifferent = function timeIsSignificantlyDifferent(time, base, delta) {
  if (delta === void 0) {
    delta = 0.2;
  }

  if (time === base) return false;

  if (!((0, _lodash.isNumber)(time) && (0, _lodash.isNumber)(base))) {
    return time !== base;
  }

  return Math.abs(time - base) > delta;
};

var AnimatorContainer = /*#__PURE__*/function (_PropsToStateComponen) {
  _inheritsLoose(AnimatorContainer, _PropsToStateComponen);

  function AnimatorContainer(props) {
    var _this;

    _this = _PropsToStateComponen.call(this, props) || this;
    _this.state = _this.propsToState(props);
    return _this;
  }

  var _proto = AnimatorContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.throttledUpdateState = (0, _lodash.throttle)(function () {
      _this2.updateState();
    }, 100);
  };

  _proto.updateState = function updateState() {
    var _this3 = this;

    var oldTurnFrame = (0, _lodash.get)(this.state, "turnFrame", -1);
    var newState = this.propsToState(); // setState callback checks current scroll position and desired scroll position,
    // rangeBrackets, and if skip prev/next button clicked

    this.setState(newState, function () {
      if (newState.turnFrame !== oldTurnFrame && newState.turnFrame > -1 || _this3.props.scrollRef.scrollTop !== _this3._desiredScrollY && (newState.identifiedRangeBrackets.length > 0 || _this3.props.skipPrevNextHit)) {
        _this3.scrollTranscript();
      }
    });
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // Force animator scroller component to re-render when skipping to next/previous
    // hit. This is needed for single instance of keyword to scroll back to it if
    // user scrolls to another part of the transcript.
    if (nextProps.skipPrevNextHit) {
      return true;
    }

    if (timeIsSignificantlyDifferent(this.state.currentTime, nextState.currentTime) || timeIsSignificantlyDifferent(this.state.currentTime, nextProps.currentTime)) {
      return true;
    }

    if (!(0, _compareRangeLists["default"])(this.state.transcriptTimeRanges, nextState.transcriptTimeRanges) || !(0, _compareRangeLists["default"])(this.state.transcriptTimeRanges, nextProps.transcriptTimeRanges)) {
      return true;
    }

    if (!(0, _deepEqual["default"])(this.state.identifiedRangeBrackets, nextState.identifiedRangeBrackets) || !(0, _deepEqual["default"])(this.state.identifiedRangeBrackets, nextProps.identifiedRangeBrackets)) {
      return true;
    }

    if (this.state.currentPosition !== nextProps.currentPosition) {
      return true;
    }

    return false;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (!(0, _deepEqual["default"])(this.state, this.propsToState())) {
      if (this.throttledUpdateState) {
        this.throttledUpdateState();
      } else {
        this.updateState();
      }
    }
  };

  _proto.getFrame = function getFrame(pProps, ifNotFound) {
    if (ifNotFound === void 0) {
      ifNotFound = -1;
    }

    var props = pProps || this.props;
    var currentTime = props.currentTime,
        currentPosition = props.currentPosition,
        transcriptTimeRanges = props.transcriptTimeRanges,
        paused = props.paused,
        onSeek = props.onSeek;

    if (!(0, _lodash.isNumber)(currentTime) || !transcriptTimeRanges) {
      return -1;
    } // Highlight words by word timestamp as they are spoken for media types with a player (speech)


    if (!currentPosition || !paused) {
      var _Range$nearestRange = _Range["default"].nearestRange(transcriptTimeRanges, currentTime),
          _nearest = _Range$nearestRange.nearest,
          found = _Range$nearestRange.found;

      return _nearest === null || _nearest === void 0 ? void 0 : _nearest.name;
    } // Otherwise highlight words by word position when clicked or searched


    var nearest = transcriptTimeRanges.find(function (i) {
      return i.name === currentPosition;
    });
    return (nearest === null || nearest === void 0 ? void 0 : nearest.name) || currentPosition;
  }
  /**
   * determines which turn a particular time intersects with.
   * @param pProps {Object}? optional represents the props to calculate for.
   * @param ifNotFound {int}? optional, what to return if a time block is not found.
   * @returns {*}
   */
  ;

  _proto.getTurnFrame = function getTurnFrame(pProps, ifNotFound) {
    if (ifNotFound === void 0) {
      ifNotFound = -1;
    }

    var _ref = pProps || this.props,
        transcriptsBySpeaker = _ref.transcriptsBySpeaker,
        currentTime = _ref.currentTime;

    if (!(transcriptsBySpeaker && transcriptsBySpeaker.type === _constants.TYPE_ARRAY)) return ifNotFound;
    var time = currentTime;
    var speakerStartFrame = ifNotFound;

    for (var i = 0; i < transcriptsBySpeaker.value.length; i += 1) {
      var speaker = transcriptsBySpeaker.value[i];

      if (speaker && speaker.has("speaker")) {
        if (speaker.type === _constants.TYPE_ARRAY) {
          var ps = speaker.getAll("p");

          if (ps && ps instanceof Set && ps.size > 0) {
            speakerStartFrame = _(Array.from(ps.values())).filter(function (n) {
              return (0, _lodash.isNumber)(n);
            }).min();
          }
        }

        if (speaker.containsTime(time) || speaker.start >= time) {
          return speakerStartFrame;
        }
      }
    }

    return speakerStartFrame;
  };

  _proto.propsToState = function propsToState(pProps) {
    var props = pProps || this.props;
    var out = {
      transcriptTimeRanges: props.transcriptTimeRanges,
      transcriptsBySpeaker: props.transcriptsBySpeaker,
      identifiedRangeBrackets: props.identifiedRangeBrackets,
      scrollHeight: props.scrollHeight,
      currentTime: (0, _lodash.get)(props, "currentTime", 0),
      frame: this.getFrame(props),
      turnFrame: this.getTurnFrame(props),
      currentPosition: props.currentPosition
    };
    return out;
  }
  /**
   * this is a property hook to the scrollRef's scroll Y value
   * @returns {*|number}
   */
  ;

  /**
   * reset state to the non-transitioning state and if
   * necessary force the scroll to the desired endpoint
   *
   * @param why
   * @private
   */
  _proto._completeScrolling = function _completeScrolling(why) {
    if (this.desiredScrollY !== this.transcriptScrollY) {
      this.transcriptScrollY = this.desiredScrollY;
    }

    this.setState({
      transition: false,
      scrolling: false
    });
    this.props.onSkipPrevNextHit(false);
  }
  /**
   * scrolls the transcript by a (hopefully) small amount based on
   * a smoothed interpolation of time and desired distance.
   * @returns {boolean}
   * @private
   */
  ;

  _proto._updateScroll = function _updateScroll() {
    if (this.transitionHasExpired(true)) {
      this._completeScrolling("_updateScroll: expired time", this.state.transition);

      return false;
    }

    if (this.desiredScrollY === this.transcriptScrollY) {
      this._completeScrolling("_updateScroll: already there", this.state.transition);

      return false;
    }

    var _transitionSize = this._transitionSize,
        _transitionPercentComplete = this._transitionPercentComplete,
        _transitionStartY = this._transitionStartY;

    if (!((0, _lodash.isNumber)(_transitionPercentComplete) && (0, _lodash.isNumber)(_transitionStartY) && (0, _lodash.isNumber)(_transitionPercentComplete))) {
      this._completeScrolling("non-numeric values");

      return false;
    }

    var delta = easing(_transitionPercentComplete) * _transitionSize;

    this.transcriptScrollY = Math.round(_transitionStartY + delta);
    return true;
  }
  /**
   * boolean - true if there is no transition
   * or if the allotted time to complete
   * the transition has expired.
   *
   * @returns {boolean}
   */
  ;

  _proto.transitionHasExpired = function transitionHasExpired() {
    if (!this.state.transition) return true;
    var startTime = (0, _lodash.get)(this.state, "transition.start");
    var endTime = startTime + SCROLL_INTERVAL;
    var now = Date.now();

    if (!startTime || !(0, _lodash.isNumber)(startTime)) {
      return false;
    }

    if (endTime < now) {
      return true;
    }

    return false;
  }
  /**
   * start a repeating animation scroll
   * is possible.
   */
  ;

  _proto._startScrolling = function _startScrolling(newY) {
    var _this4 = this;

    if (!this.state.scrolling) {
      this.setState({
        scrolling: true,
        transition: {
          startY: this.transcriptScrollY,
          newY: newY,
          start: Date.now()
        }
      }, function () {
        var update = function update() {
          if (!_this4.state.transition) {
            _this4._completeScrolling("no transition");

            return false;
          }

          if (_this4._updateScroll() && window) {
            window.requestAnimationFrame(update);
          } else {
            _this4._completeScrolling("because _updteScroll told us to");
          }
        };

        if (window) {
          window.requestAnimationFrame(update);
        } else {
          _this4._completeScrolling();
        }
      });
    }
  }
  /**
   * initiates a scroll to the Y position of the desired turn.
   */
  ;

  _proto.scrollTranscript = function scrollTranscript() {
    var _this$props$scrollRef;

    var _this$props = this.props,
        scrollRef = _this$props.scrollRef,
        paused = _this$props.paused;
    var turnFrame = this.state.turnFrame;
    var frame = this.state.frame;

    if (!scrollRef || turnFrame < 0) {
      return;
    } // the turn Div that contains the transcript
    // word-index-frame is geared for chat/text/msg media due to implementation of turns array


    var turnElement = ((_this$props$scrollRef = this.props.scrollRef.querySelector(".word-index-" + frame)) === null || _this$props$scrollRef === void 0 ? void 0 : _this$props$scrollRef.closest(".transcript-turn")) || this.props.scrollRef.querySelector(".turn-p-start-" + turnFrame) || this.props.scrollRef.querySelector(".chat-turn-time-scroll-true") || this.props.scrollRef.querySelector(".chat-turn-range-true");

    if (turnElement) {
      this.desiredScrollY = turnElement.offsetTop;
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_AnimatorView["default"], this.state);
  };

  _createClass(AnimatorContainer, [{
    key: "transcriptScrollY",
    get: function get() {
      return (0, _lodash.get)(this.props, "scrollRef.scrollTop") || 0;
    },
    set: function set(n) {
      if (!(0, _lodash.isNumber)(n)) {
        return;
      }

      if (this.props.scrollRef) {
        this.props.scrollRef.scrollTop = n;
      }
    }
    /**
     * this is a "fly by wire" property that initiates an async transition from its
     * previous value to its current one.
     *
     * note - the value of this property is what we expect the scroll to be EVENTUALLY.
     * @returns {*|number}
     */

  }, {
    key: "desiredScrollY",
    get: function get() {
      return this._desiredScrollY || 0;
    },
    set: function set(newY) {
      this._desiredScrollY = newY;

      if (newY !== this.transcriptScrollY) {
        this._startScrolling(newY);
      }
    }
    /**
     * the distance between the scrollY of the transcript before the scrolling started
     * and the desired scrollY of the transcript
     * @returns {float}
     * @private
     */

  }, {
    key: "_transitionSize",
    get: function get() {
      if (!this.state.transition) return 0;
      var _this$state$transitio = this.state.transition,
          startY = _this$state$transitio.startY,
          newY = _this$state$transitio.newY;
      if (!((0, _lodash.isNumber)(startY) && (0, _lodash.isNumber)(newY))) return 0;
      return newY - startY;
    }
    /**
     * The percent complete (linear, 0..1) that the scrolling shouold be, between the start
     * of the transition and that time + SCROLL_INTERVAL
     * @returns {number}
     * @private
     */

  }, {
    key: "_transitionPercentComplete",
    get: function get() {
      if (this.transitionHasExpired(true)) return 1;
      var startTime = (0, _lodash.get)(this.state, "transition.start");

      if (!(0, _lodash.isNumber)(startTime)) {
        return 1;
      }

      return (0, _lodash.clamp)((Date.now() - startTime) / SCROLL_INTERVAL, 0, 1);
    }
  }, {
    key: "_transitionStartY",
    get: function get() {
      return (0, _lodash.get)(this.state, "transition.startY", 0);
    }
  }]);

  return AnimatorContainer;
}(_PropsToStateComponent["default"]);

var _default = (0, _connectToScroller["default"])((0, _connectToTranscript["default"])(AnimatorContainer));

exports["default"] = _default;